import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/backdrop.jpg")